import { Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { defaultsDeep, filter, isEmpty } from 'lodash';
import { LayoutService } from '../../../Services/layout/layout.service';
import { ObservablesService } from '../../../Services/observables/observables';
import { StoreService } from 'src/app/Services/store';
import { SplunkAnalyticsService } from 'src/app/Services/splunk-analytics/splunk-analytics-service';
import { ModalService } from '../../../Services/modal-factory/modal-factory';

@Component({
	selector: 'modal',
	encapsulation: ViewEncapsulation.None,
	template: `
		<div class="modal-container" id="modalcontainer" [ngClass]="modal.data.attributes.type">
			<div class="close-box" *ngIf="modal.data.attributes.showCloseIcon">
				<button
					tabindex="0"
					class="icon icon-close"
					(click)="close(); eventOnCloseModal()"
					gtm-handler
					events="click"
					handlerType="button"
					[label]="gaLabel"
					action="ButtonClick"
					aria-label="Close modal"
				></button>
			</div>
			<ng-container *ngIf="infoWeFoundMvp">
				<control
					*ngFor="let control of modal.data.controls; trackBy: trackById; let last = last"
					[hidden]="control.visible"
					context="modal"
					[control]="control"
					[isLast]="last"
					[ngClass]="class"
					(allControlsGenerated)="onAllControlsGenerated()"
				>
				</control>
			</ng-container>
			<ng-container *ngIf="!infoWeFoundMvp">
				<control
					*ngFor="let control of modal.data.controls"
					[hidden]="control.visible"
					context="modal"
					[control]="control"
					[ngClass]="class"
				>
				</control>
			</ng-container>
		</div>
	`,
	styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
	@Input() modal;
	@Input() closeModal;
	@Input() modalRef;
	globalListenFunc: Function;
	infoWeFoundMvp: boolean;
	gaLabel: string;
	class: attributes;

	constructor(
		private observablesService: ObservablesService,
		private renderer: Renderer2,
		private el: ElementRef,
		private modalFactory: ModalService,
		private storeService: StoreService,
		private layoutService: LayoutService,
		private splunkAnalyticsService: SplunkAnalyticsService
	) {}

	dismissModal() {}

	getClass() {
		if (!isEmpty(this.modal.data.attributes)) {
			return this.modal.data.attributes;
		}
	}

	ngOnInit() {
		if (this.modal.data.attributes && this.modal.data.attributes.hasSectionClaim) {
			this.storeService.updateData(this.modal.data.name, true, 'modal');
		}

		this.modal.data.controls = filter(this.modal.data.controls, function (p) {
			return p.visible;
		});

		this.infoWeFoundMvp = this.modal.data.attributes && this.modal.data.attributes.infoWeFoundMvp;
		if (this.infoWeFoundMvp) {
			this.splunkAnalyticsService.publish('Display', 'InfoWeFound_Edit_Popup');
		}

		this.layoutService.staticLayout.subscribe((data) => {
			if (data) {
				setTimeout(() => {
					this.scrollToErrorElement();
				}, 300);
			}
		});

		this.observablesService.modalUpdated.subscribe((res: any) => {
			if (this.modal.data.attributes && this.modal.data.attributes.hasSectionClaim) {
				this.storeService.updateData(this.modal.data.name, true, 'modal');
			}

			if (res.instruction && res.instructions.data == 'merge') {
				defaultsDeep(this.modal.data.controls, this.modal.data.controls, res.controls);
			} else {
				this.modal.data.controls = filter(res.controls, function (p) {
					return p.visible;
				});
				if (res.attributes !== undefined) {
					this.modal.data.attributes.showCloseIcon = res.attributes.showCloseIcon;
				}
			}

			var modalWindow = document.querySelector('ngb-modal-window');
			if (modalWindow) {
				this.renderer.removeClass(modalWindow, 'large');
				this.renderer.removeClass(modalWindow, 'Small');
				this.renderer.addClass(modalWindow, res.windowClass);
			}

			//scroll to error
			const modalCon = document.getElementsByClassName('modal-container')[0];
			const errors = modalCon.getElementsByClassName('error-container');
			if (errors) {
				if (errors[0]) {
					errors[0].scrollIntoView({
						behavior: 'smooth',
						block: 'end',
						inline: 'nearest',
					});
					this.scrollToErrorElement();
				}
			}
		});

		this.globalListenFunc = this.renderer.listen('document', 'keydown', (e) => {
			if (e.keyCode === 27)
				// ESC key
				this.closeModal();
		});
		this.gaLabel = this.getLabel();
		this.class = this.getClass();

		setTimeout(() => {
			var modalElem = document.getElementsByClassName('modal-backdrop')[0];
			modalElem.classList.add('popup-modal-backdrop');
			var modalElem = document.getElementsByClassName('modal')[0];
			modalElem.classList.add('popup-modal');
		}, 0);
	}

	getLabel() {
		if (this.modal.data.name === 'Modal.CarrierFeaturesBenefitsModal') {
			return 'Close_Features_and_Benefits_Window';
		}
		return this.modal.data.attributes && this.modal.data.attributes.closeGaLabel
			? this.modal.data.attributes.closeGaLabel
			: this.modal.data.name
			? this.modal.data.name + '_Close'
			: null;
	}

	trackById(index, item) {
		return item.id;
	}

	scrollToErrorElement() {
		var el = document.querySelectorAll('question.error')[0];
		if (!el) {
			return;
		}
		var top = el.getBoundingClientRect().top + document.querySelector('ngb-modal-window').scrollTop;
		document.querySelector('ngb-modal-window').scrollTop = top - 40;
	}

	eventOnCloseModal() {
		if (this.infoWeFoundMvp) {
			this.splunkAnalyticsService.publish('ButtonClick', 'InfoWeFound_Edit_Popup_Close');
		}
	}

	onAllControlsGenerated(): void {
		setTimeout(() => {
			this.modalFactory.allModalControlsGenerated.next();
		}, 1);
	}

	close() {
		const globalAttributes = this.layoutService.globalAttributes.getValue();
		this.layoutService.globalAttributes.next(globalAttributes);
		setTimeout(() => {
			this.closeModal();
		}, 0);
	}
}
